/**
 * @param user1
 * @param user2
 * @deprecated We don't concatenate to create room names anymore
 * @returns {string}
 */
export const getConversationKey = (user1, user2) => {
  if (user1.localeCompare(user2) < 0) return `conversation:${user1}+${user2}`;
  return `conversation:${user2}+${user1}`;
};

/**
 * Attempts to find a room matching the parameters
 * @param {Room[]} rooms
 * @param {String} roomId
 * @param {String} contactInternalId
 * @param {String} channelName
 */
export const getRoom = (rooms, roomId, contactInternalId = '', channelName = '') => {
  return rooms.find(room => {
    if (roomId)
      return room.id === roomId;

    if (contactInternalId)
      return room.usersInternalIds.includes(contactInternalId);

    if (channelName)
      return room.channelName === channelName;
  });
};



// WEBPACK FOOTER //
// ./utils.js